var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade show",
      staticStyle: { display: "block" },
      attrs: {
        id: "go-modal-pin-limit",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-alert" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("i", { staticClass: "go-icon-40 go-icon-alert-circle" }),
              _vm._v(" "),
              _c("P", { staticClass: "lead" }, [
                _vm._v(_vm._s(_vm.$t("briefing.popup.pinAlert.content-1"))),
                _c("br"),
                _vm._v(_vm._s(_vm.$t("briefing.popup.pinAlert.content-2"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleCloseModal },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("briefing.popup.pinAlert.submit-button")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }